import {ReactElement} from "react";
import {styles} from "./styles/DropdownFilterVerticalDivider.style";

const DropdownFilterVerticalDivider = (): ReactElement => (
    <div style={styles.DropdownFilterVerticalDivider}></div>
);

export default DropdownFilterVerticalDivider;